export function sortSelectedToTop(options, selectedOptions) {
  const selectedKeys = new Set(selectedOptions.map((option) => option.value));
  return [...options].sort((a, b) => {
    const aSelected = selectedKeys.has(a.value);
    const bSelected = selectedKeys.has(b.value);
    if (aSelected === bSelected) return 0;
    return aSelected ? -1 : 1;
  });
}
